import { FC } from 'react'
import { DownloadIcon, PaperclipIcon } from 'lucide-react'
import { useAppSelector } from '../../../redux'
import { LessonType } from '../../../types'
import { useSegment } from '../../../utils'
import { StyledLessonResourceListItem } from '.'

type Props = {
  resource: NonNullable<LessonType['additionalFiles'][number]>
}

const LessonResourceListItem: FC<Props> = ({ resource }) => {
  const { track } = useSegment()
  const { lesson } = useAppSelector((state) => state.course)

  return (
    <StyledLessonResourceListItem
      href={resource?.file?.fileHttpLink}
      target="_blank"
      onClick={() =>
        track('Downloaded Lesson Resource', { label: resource.label, lesson_id: lesson?._id })
      }
    >
      <div className="details">
        <div className="icon">
          <PaperclipIcon />
        </div>
        <div className="label">{resource.label}</div>
      </div>
      <DownloadIcon className="download-icon" />
    </StyledLessonResourceListItem>
  )
}

export default LessonResourceListItem
